import {
  SET_PICKUP_PERSON_FORM,
  RESET_PICKUP_PERSON_FORM,
  SET_PICKUP_PERSON_FORM_FIELD
} from './actionTypes'

export const setPickupPersonForm = data => {
  return {
    type: SET_PICKUP_PERSON_FORM,
    data
  }
}

export const resetPickupPersonForm = () => {
  return {
    type: RESET_PICKUP_PERSON_FORM
  }
}

export const setPickupPersonFormField = (field, value) => {
  return {
    type: SET_PICKUP_PERSON_FORM_FIELD,
    field,
    value
  }
}
